document.addEventListener('DOMContentLoaded', function () {

    const addPageWidth = (accountFormContainer) => {
        if (accountFormContainer) {
            const contactFormContainer = accountFormContainer.previousSibling;
            const parentElement = accountFormContainer.parentElement;
            const newContainer = document.createElement('div');
            newContainer.classList.add('codext-container');
            parentElement.insertBefore(newContainer, contactFormContainer);
            newContainer.appendChild(contactFormContainer);
            newContainer.appendChild(accountFormContainer);
            newContainer.style.zIndex = '1';
        }
    }
    const accountFormContainer = document.querySelector('aside.shopify-section');
    addPageWidth(accountFormContainer);
});